<template>
  <div id="contact" class="container text-base px-4 lg:px-8 pb-20">
    <div>
      <h1
        class="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl pt-10 pb-10"
      >
        <span class="block xl:inline" v-if="$i18n.locale === 'de'"
          >Kontakt</span
        >
        <span class="block xl:inline" v-if="$i18n.locale !== 'de'"
          >Contact</span
        >
      </h1>
      <div>
        <section class="mb-6">
          <div
            class="lg:inline-block align-top lg:w-3/12 bullet font-bold"
            v-if="$i18n.locale === 'de'"
          >
            Adresse
          </div>
          <div
            class="lg:inline-block align-top lg:w-3/12 bullet font-bold"
            v-if="$i18n.locale !== 'de'"
          >
            Address
          </div>
          <div
            class="lg:inline-block align-top lg:w-8/12 w-full"
            v-if="$i18n.locale === 'de'"
          >
            <span v-html="addressDe"></span>
          </div>
          <div
            class="lg:inline-block align-top lg:w-8/12 w-full"
            v-if="$i18n.locale !== 'de'"
          >
            <span v-html="addressEn"></span>
          </div>
        </section>
        <section class="mb-6">
          <div class="lg:inline-block lg:w-3/12 bullet font-bold">E-Mail</div>
          <div class="lg:inline-block lg:w-8/12 w-full">
            <a :href="`mailto:${email}`">{{ email }}</a>
          </div>
        </section>
        <section class="mb-6">
          <div class="lg:inline-block lg:w-3/12 bullet font-bold">Website</div>
          <div class="lg:inline-block lg:w-8/12 w-full">
            <a :href="websiteHref">{{ websiteLabel }}</a>
          </div>
        </section>
        <section class="mb-6">
          <div class="lg:inline-block lg:w-3/12 bullet font-bold">
            Mobil-Nr.
          </div>
          <div class="lg:inline-block lg:w-8/12 w-full">
            <a :href="`tel:${phoneHref}`">{{ phone }}</a>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContactPage",
  props: {
    addressDe: {
      type: String,
      default: "AJL Corporate Advisors GmbH<br />Neue Welt Gasse 9<br />1130 Wien",
    },
    addressEn: {
      type: String,
      default:
        "AJL Corporate Advisors GmbH<br />Neue Welt Gasse 9<br />1130 Vienna",
    },
    email: {
      type: String,
      default: "andreas.ludwig@ajl-advisors.com",
    },
    phone: {
      type: String,
      default: "+43 664 8373880",
    },
    phoneHref: {
      type: String,
      default: "+436648373880",
    },
    websiteHref: {
      type: String,
      default: "https://ajl-advisors.com",
    },
    websiteLabel: {
      type: String,
      default: "ajl-advisors.com",
    },
  },
};
</script>
